<section class="trusted-users">
    <div class="container">
        <div class="text-center">
            <div class="heading-title mb-3">
                Trusted by Professionals
            </div>
            <p>
                Millions rely on The PDF Leader for secure PDF management.
            </p>
            <div>
                <img src="assets/images/siteseal-positive-ssl.svg" alt="" />
            </div>
        </div>

       
        <!-- <div  class="owl-carousel mt-lg-5" style="align-items: center;">
            <div class="item">
                <img src="assets/images/siteseal-positive-ssl.svg" alt="" />
            </div>
        </div> -->
    </div>
</section>